import { useState } from "react";
import "./ModalDetallesCita.css";

const ModalDetallesCita = ({ isOpen, onClose, cita }) => {
  if (!isOpen || !cita) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("es-ES", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatShortDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  const getStateColor = (state) => {
    switch (state?.toLowerCase()) {
      case "aceptado":
        return "#28a745";
      case "pendiente":
        return "#ffc107";
      case "rechazado":
        return "#dc3545";
      default:
        return "#6c757d";
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-detalles-cita" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Detalles de la Cita</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="cita-info-grid">
            {/* Estado y Fecha */}
            <div className="info-section">
              <h3>Estado y Programación</h3>
              <div className="info-row">
                <span className="label">Estado:</span>
                <span
                  className="estado-badge"
                  style={{ backgroundColor: getStateColor(cita.state) }}
                >
                  {cita.state}
                </span>
              </div>
              <div className="info-row">
                <span className="label">Fecha y hora:</span>
                <span className="value">
                  {formatDate(cita.appointmentDate)}
                </span>
              </div>
              <div className="info-row">
                <span className="label">Asunto:</span>
                <span className="value">{cita.subject}</span>
              </div>
              <div className="info-row">
                <span className="label">Servicio:</span>
                <span className="value">{cita.service}</span>
              </div>
            </div>

            {/* Información del Ciudadano */}
            <div className="info-section">
              <h3>Información del Ciudadano</h3>
              <div className="info-row">
                <span className="label">Nombre:</span>
                <span className="value">{cita.name}</span>
              </div>
              <div className="info-row">
                <span className="label">DNI:</span>
                <span className="value">{cita.dni}</span>
              </div>
              <div className="info-row">
                <span className="label">Email:</span>
                <span className="value">{cita.email}</span>
              </div>
              <div className="info-row">
                <span className="label">Teléfono:</span>
                <span className="value">{cita.phone}</span>
              </div>
              <div className="info-row">
                <span className="label">Dirección:</span>
                <span className="value">{cita.address}</span>
              </div>
            </div>

            {/* Información de Gestión */}
            <div className="info-section">
              <h3>Información de Gestión</h3>
              <div className="info-row">
                <span className="label">Fecha de creación:</span>
                <span className="value">{formatShortDate(cita.createdAt)}</span>
              </div>
              <div className="info-row">
                <span className="label">Última actualización:</span>
                <span className="value">{formatShortDate(cita.updatedAt)}</span>
              </div>
              <div className="info-row">
                <span className="label">Respuesta leída:</span>
                <span className="value">
                  {cita.isResponseRead ? "Sí" : "No"}
                </span>
              </div>
              {cita.responseMessage && (
                <div className="info-row full-width">
                  <span className="label">Mensaje de respuesta:</span>
                  <span className="value response-message">
                    {cita.responseMessage}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalDetallesCita;
